import { ALL_COUNTRY_LIST } from './actionType'

//
export const allCountryList = (data) => ({
  type: ALL_COUNTRY_LIST,
  payload: data,
})
